import React, { useState } from "react";
import "./Projects.css";
import SingleProject from "./SingleProject";
import Slide from "react-reveal/Slide";
const Projects = () => {
  const [projectData, setProjectData] = useState([
    {
      name: "Let's Cleaning",
      des: "This is a service provider MERN-stack web app.",
      img: "https://i.ibb.co/s6Zg1gk/cleaning.png",
      modal: (
        <div>
          <p>This is a service provider MERN-stack web app.</p>
          <h5> User Panel: -</h5>
          <ul>
            <li>User a have dashboard.</li>
            <li>User can book service dynamically</li>
            <li>User can see all service what he or she booked</li>
            <li>User can give review dynamically.</li>
            <li>User has authentication with the private route.</li>
          </ul>
          <h5> Admin Panel: -</h5>
          <ul>
            <li>Admin has a different dashboard than the user.</li>
            <li>Admin has authentication with the private route.</li>
            <li>Admin can see all booking what user was booked.</li>
            <li>Admin can delete service.</li>
            <li>Admin can add service.</li>
          </ul>
          <h5> Use Technology: -</h5>
          <ul>
            <li>
              HTML, CSS, JavaScript, React, Bootstrap, Firebase Authentication,
              Node.js, Express.js, MongoDB, Heroku.
            </li>
          </ul>
        </div>
      ),
      git:
        "https://github.com/Porgramming-Hero-web-course/complete-website-server-hadidbilla",
      live: "https://lets-cleaning.web.app/",
    },
    {
      name: "Buy Valley",
      des: "This is a service provider MERN-stack web app.",
      img: "https://i.ibb.co/PwBrd0t/buy.png",
      git:
        "https://github.com/Porgramming-Hero-web-course/full-stack-server-hadidbilla",
      live: "https://buy-valley.web.app/",
    },
    {
      name: "Buj-Al-Arab",
      des: "This is a service provider MERN-stack web app.",
      img: "https://i.ibb.co/DQpTtHB/buj.png",
      git: "https://github.com/hadidbilla/burj-arab-hotel",
      live: "https://admiring-einstein-4078cd.netlify.app/",
    },
    {
      name: "Hard Rock Music",
      des: "This is Html,css and javascript",
      img: "https://i.ibb.co/1TxFD9y/musci.png",
      git: "https://github.com/hadidbilla/hard-rock",
      live: "https://hadidbilla.github.io/hard-rock/",
    },
  ]);
  return (
    <div className="project-header">
      <h1 className="text-center project-title" id="Projects">
        My <span style={{ color: "crimson" }}>Project</span>
      </h1>
      <div className="container">
        <Slide left>
          <div className="row pb-5">
            {projectData.map((data) => (
              <SingleProject data={data}></SingleProject>
            ))}
          </div>
        </Slide>
      </div>
    </div>
  );
};

export default Projects;
